<template>
  <div
    class="checkout-app"
    :class="{ mobile: isMobile(), ...(config.appClass || {}) }"
    v-apply-theme
  >
    <CheckoutHeader :key="headerKey"/>
    <router-view @onError="errorHandler"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import debug from 'debug';
import Logger from '@/lib/logger';
import UtilMixing from '@/mixins/util';
import { ApplyTheme } from '@/directives/applyTheme';
import CheckoutHeader from '../components/CheckoutHeader.vue';
import mockInit from '../mock.init';

const log = debug('vue:checkout:template');

export default {
  name: 'checkout-template',
  metaInfo: {
    title: 'Pagar',
  },
  mixins: [UtilMixing],
  components: {
    CheckoutHeader,
  },
  data: () => ({
    width: null,
    height: null,
    headerKey: 1,
  }),
  computed: {
    ...mapState('checkout', ['config']),
  },
  directives: {
    ApplyTheme,
  },
  methods: {
    ...mapActions('checkout', [
      'setContext',
      'ready',
      'getLastState',
      'error',
      'windowResized',
      // this actions must be async functions for message handler top level await
      // vuex - postMessage actions binded
      'init',
      'shippingChanged',
      'checkoutDataChanged',
      'setInstallmentIndex',
      'setDownPaymentIndex',
    ]),
    errorHandler(error) {
      Logger.error(error);
      if (error && error.request && error.request.status === 400) {
        this.$router.replace({ name: 'checkout-error' });
      } else {
        if (this.goneToError) return;
        this.$router.replace({ name: 'checkout-error' });
        this.error(error);
      }
    },
    async messageHandler(message) {
      const messageData = message.data;

      // binded message.ev to vuex actions
      if (
        [
          'init',
          'shippingChanged',
          'checkoutDataChanged',
          'setInstallmentIndex',
          'setDownPaymentIndex',
        ].includes(messageData.ev)
        && this[messageData.ev]) {
        log(messageData.ev, messageData.data);
        try {
          await this[messageData.ev](messageData.data);
          if (messageData.ev === 'init') {
            this.headerKey += 1;
          }
        } catch (error) {
          this.errorHandler(error);
        }
      } else if (messageData.ev) {
        log(`no handler on: ${messageData.ev}`);
      }
    },
    onResize() {
      this.windowResized({
        width: this.windowWidth,
        height: this.windowHeight,
      });
    },
  },
  watch: {
    windowHeight(newValue) {
      if (newValue !== this.height) {
        this.width = this.windowWidth;
        this.height = this.windowHeight;
        this.onResize();
      }
    },
    windowWidth(newValue) {
      if (newValue !== this.width) {
        this.width = this.windowWidth;
        this.height = this.windowHeight;
        this.onResize();
      }
    },
  },
  created() {
    this.setContext(this.$route.params.context).catch(this.errorHandler);
  },
  destroyed() {
    window.removeEventListener('message', this.messageHandler);
  },
  mounted() {
    window.addEventListener('message', this.messageHandler);
    if (this.$route.query.mock) {
      this.messageHandler(mockInit);
    } else if (this.$route.query.checkoutId) {
      this.getLastState({
        checkoutId: this.$route.query.checkoutId,
        sessionId: this.$route.query.sessionId,
      });
    } else {
      this.ready().catch(this.errorHandler);
    }
  },
};
</script>

<style lang="scss" scoped>
  .checkout-app {
    box-sizing: border-box;
    position: relative;
    height: 100vh;
    margin: 0 auto;
    &--vivo {
      padding-left: 35px !important;
      padding-right: 61px !important;
      padding-top: 48px !important;
      padding-bottom: 24px !important;

      &.mobile {
        padding: 0px !important;
      }
    }
    &.vtex {
      padding: 0px;
    }
    &.zoom {
      width: 100%;
      padding: 0 24px;
    }
  }
</style>
